import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cb78918"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form__subfieldset" }
const _hoisted_2 = { class: "form__sublegend" }
const _hoisted_3 = {
  key: 0,
  class: "form__field"
}
const _hoisted_4 = { class: "form__field-readonly" }
const _hoisted_5 = { class: "occupied-places" }

import {ref, watch} from "vue";
import {minDate, required} from "@/validation/rules";
import {useI18n} from "vue3-i18n";
import FormInput from "@/components/forms/FormInput.vue";
import FormRow from "@/components/forms/FormRow.vue";
import {Status} from "@/validation";
import IconParticipants from "@/assets/icons/icon__person.svg"
import IconDelete from "@/assets/icons/icon__delete.svg"


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityScheduleForm',
  props: {
    index: {},
    id: {},
    activityId: {},
    startDate: {},
    endDate: {},
    maxParticipants: {},
    occupiedPlaces: {}
  },
  emits: ["update:startDate", "update:endDate", "handleValidation", "registerFormInputRef", "addActivityOccurrenceRow", "removeActivityOccurrenceRow"],
  setup(__props: any, { emit: __emit }) {

const {t} = useI18n();

// eslint-disable-next-line no-undef
const props = __props;

// eslint-disable-next-line
const emit = __emit;


const occurrenceStartDate = ref(props.startDate ? props.startDate : "");
watch(occurrenceStartDate, (newValue) => emit("update:startDate", newValue));

const occurrenceEndDate = ref(props.endDate ? props.endDate : "");
watch(occurrenceEndDate, (newValue) => emit("update:endDate", newValue));

watch(props, (newProps) => {
  occurrenceStartDate.value = newProps.startDate ? newProps.startDate : "";
  occurrenceEndDate.value = newProps.endDate ? newProps.endDate : "";
});

function addFormInputRef(ref: typeof FormInput) {
  emit("registerFormInputRef", ref);
}

async function handleValidation(name: string, validationStatus: Status) {
  emit("handleValidation", name, validationStatus);
}

function deleteActivityRegistrationRow() {
  emit("removeActivityOccurrenceRow", props.index)
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("legend", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('activityOccurrences.occurrence')) + " #" + _toDisplayString(_ctx.index + 1), 1),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "btn btn--square btn--red",
        onClick: deleteActivityRegistrationRow
      }, [
        _createVNode(_unref(IconDelete), { class: "icon icon--black" })
      ])), [
        [_directive_tippy, _unref(t)(`global.actions.delete`)]
      ])
    ]),
    _createVNode(FormRow, { "with-three-columns": "" }, {
      default: _withCtx(() => [
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: occurrenceStartDate.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((occurrenceStartDate).value = $event)),
          label: _unref(t)('activityOccurrences.form.startDate'),
          rules: [_unref(required)],
          name: "startDate",
          type: "date",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label", "rules"]),
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: occurrenceEndDate.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((occurrenceEndDate).value = $event)),
          label: _unref(t)('activityOccurrences.form.endDate'),
          rules: occurrenceEndDate.value.length && occurrenceStartDate.value.length ? [_unref(minDate)(occurrenceStartDate.value)] : [],
          name: "endDate",
          type: "date",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label", "rules"]),
        (props.id && props.activityId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("label", null, _toDisplayString(_unref(t)("participants.nbParticipant")), 1),
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(props.occupiedPlaces) + " / " + _toDisplayString(props.maxParticipants ?? 0), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: { 'name': 'admin.children.activities.participants.edit', 'params': { activityId: props.activityId, activityOccurrenceId: props.id } },
                  class: "btn btn--square btn--blue"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IconParticipants), { class: "icon icon--black" })
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})